import React from 'react';
import { OrganisationMasterScreen } from '../organisation/OrganisationMasterScreen';
import { businessUnitDefinition } from '../organisation/organisationDefinitions';

interface Props { moduleIcon?: string; tabId?: string; moduleName?: string }

/** Business units of a tenant — the organisation master (standard §7.5). */
const BusinessUnitMasterScreen: React.FC<Props> = (props) => (
  <OrganisationMasterScreen definition={businessUnitDefinition} {...props} />
);

export default BusinessUnitMasterScreen;
